import React, { useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import ShippingInformationModal from './ShippingInformationModal';

const Wrapper = styled.div`
  margin-top: 20px;
  cursor: pointer;
`;

function ShippingInformation() {
  const [open, setOpen] = useState(false);

  const toggle = () => {
    setOpen(false);
  };

  return (
    <Wrapper>
      <Text onClick={() => setOpen(true)}>Shipping + Returns</Text>
      <ShippingInformationModal open={open} toggle={toggle} />

      {open && <GlobalStyle open={open} />}
    </Wrapper>
  );
}

export default ShippingInformation;

const Text = styled.div`
  text-decoration: underline;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  color: ${({ theme }) => theme.colors.french};
`;

const GlobalStyle = createGlobalStyle`
  html > body {
    overflow: ${({ open }) => (open ? 'hidden' : 'auto')};
    overflow-x: hidden;
  }

  .extole-overlay-cta-wrapper {
    display: ${({ open }) => (open ? 'none' : 'auto')};
  }

  #gorgias-chat-container {
    display: ${({ open }) => (open ? 'none' : 'auto')};
  }

  #nav-banner-mobile {
    visibility: ${({ open }) => (open ? 'hidden' : 'visible')};
    display: ${({ open }) => (open ? 'none' : 'auto')};
    transition: all 1s;
  }
`;
